import BusinessService from './business-service';

export default class BusinessServiceDesktop extends BusinessService {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/business/service/business-service.desktop.js